<template>
  <el-dialog
    :visible.sync="isVisible"
    width="414px"
    center
  >
    <div class="user-wrap">
      <div class="user-avatar-wrap flex-center"><span class="iconfont user-avatar">&#xe8a2;</span></div>
      <p>
        <span class="user-name">{{ data.nickname }}</span>
        <span class="role">{{ data.roleName }}</span>
      </p>
    </div>

    <div class="store-wrap" :class="{'is-spread' : isSpread}">
      <p class="store-title" @click="clickSpread">
        工作于{{ (data.customers && data.customers.length) || 0 }}家门店
        <i class="header-icon el-icon-arrow-down"></i>
      </p>
      <ul class="store-content">
        <el-scrollbar>
          <li v-for="item in data.customers" :key="item.customerNumber" class="store-item">
            <p class="one_txt_cut">{{ item.customerNumber }} {{ item.programType }}</p>
            <p class="name one_txt_cut">{{ item.customerName }}</p>
          </li>
        </el-scrollbar>
      </ul>
    </div>

    <ul slot="footer" class="nav-footer">
      <li class="nav-item" @click="makingCalls">
        <div class="icon-wrap"><span class="iconfont">&#xe663;</span></div>
        <p>拨打电话</p>
      </li>
      <li
        v-if="!userParent.isPermissionDisabled(`DCP-MA-P-${theme.toUpperCase()}`)"
        class="nav-item"
        :class="{'is-disabled': userParent.isPermissionDisabled(`DCP-MA-P-${theme.toUpperCase()}`)}"
        @click="changePermission"
      >
        <div class="icon-wrap"><span class="iconfont">&#xe661;</span></div>
        <p>修改权限</p>
      </li>
      <li
        v-if="!userParent.isPermissionDisabled(`DCP-MD-P-${theme.toUpperCase()}`)"
        class="nav-item delete"
        :class="{'is-disabled': userParent.isPermissionDisabled(`DCP-MD-P-${theme.toUpperCase()}`)}"
        @click="moveOutStore"
      >
        <div class="icon-wrap"><span class="iconfont">&#xe662;</span></div>
        <p>移出门店</p>
      </li>
    </ul>
  </el-dialog>
</template>

<script>
export default {
  name: 'UserInfo',
  inject: ['userParent'],
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      isSpread: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    },
    theme() {
      return this.$store.getters.theme
    },
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    role() {
      return this.$store.getters.roleList[0].roleName
    }
  },
  watch: {
    isVisible(val) {
      if (!val) {
        this.isSpread = false
      }
    }
  },
  mounted() {

  },
  methods: {
    clickSpread() {
      this.gtag('event', 'usr_profile_popup')
      this.isSpread = !this.isSpread
    },
    makingCalls() {
      this.gtag('event', 'usr_call_staff')
      const h = this.$createElement
      this.$msgbox({
        title: '电话号码',
        message: h('div', { style: 'text-align: center' }, [
          h('p', null, `${this.data.loginCode}`)
        ]),
        showCancelButton: false,
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn'
      }).then(action => {})
    },
    changePermission() {
      this.gtag('event', 'usr_edit_staff_start')
      this.userParent.getStaffOauth(this.data.loginCode, 'edit').then(res => {
        this.userParent.isShowAddUser = true
        this.userParent.dialogStatus = 'edit'
      })
    },
    moveOutStore() {
      const _this = this
      const h = _this.$createElement
      this.$msgbox({
        title: '',
        message: h('div', { style: 'text-align: center' }, [
          h('span', null, `您确定要将`),
          h('i', { class: 'point' }, ` ${this.data.nickname} `),
          h('span', null, `移出门店`),
          h('i', { class: 'point' }, ` ${this.currCustomer.customerNumber} `),
          h('span', null, `？`)
        ]),
        center: true,
        confirmButtonText: '是',
        cancelButtonText: '否',
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn',
        cancelButtonClass: 'dcp-message-box-cancel-btn'
      }).then(() => {
        _this.userParent.isLoading = true
        this.$api.staff.removeStaff({ accountId: _this.data.accountId }).then(res => {
          this.gtag('event', 'usr_remove_staff_success')

          _this.userParent.isLoading = false
          _this.isVisible = false
          _this.userParent.fetchList()
        }).catch(() => {
          _this.userParent.isLoading = false
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-wrap {
  text-align: center;

  .user-avatar-wrap {
    width: 106px;
    height: 106px;
    margin: 0 auto 10px;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;

    .user-avatar {
      font-size: 52px;
    }

    @include background_color_page_primary('user-bg');
  }

  .user-name {
    font-weight: 500;
    font-size: 18px;
  }

  .role {
    padding: 0 4px;
    margin-left: 4px;
    border-radius: 4px;
    font-size: 14px;
    color: #906425;
    background-color: $color-yellow;
  }
}

.store-wrap {
  .store-title {
    width: 100%;
    margin-top: 8px;
    font-size: 18px;
    line-height: 2;
    text-align: center;
    cursor: pointer;

    @include color_page_primary('font-color-diff');
  }

  .store-content {
    max-height: 0;
    margin-top: 10px;
    overflow: hidden;
    transition: 0.3s max-height;
  }

  /deep/ .el-scrollbar__wrap {
    box-sizing: border-box;
    max-height: 79*2 + 10px;
    // padding-right: 16px;
    margin-bottom: 0 !important;
    overflow-x: hidden;
  }

  .store-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 77px;
    padding: 0 10px;
    // margin-top: 10px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 18px;

    + .store-item {
      margin-top: 10px;
    }

    .name {
      font-weight: 400;
      font-size: 16px;
    }

    @include background_color_page_primary('bg-color-light');
    @include color_page_primary('font-color-diff');
  }

  &.is-spread {
    .store-content {
      max-height: 79*2 + 10px;
    }

    .header-icon {
      transform: rotate(-90deg);
      transition: 0.3s all;
    }
  }
}

.nav-footer {
  display: flex;
  justify-content: space-around;
  align-items: center;

  .nav-item {
    font-size: 14px;
    cursor: pointer;

    .icon-wrap {
      width: 75px;
      height: 75px;
      margin-bottom: 8px;
      border-radius: 50%;
      line-height: 75px;
      text-align: center;

      .iconfont {
        font-size: 30px;

        @include color_page_primary('color');
      }

      @include background_color_page_primary('bg-color-light');
    }

    &.delete {
      .icon-wrap {
        background: #ffc7bc !important;

        .iconfont {
          color: #d81e06 !important;
        }
      }
    }
  }
}

</style>
